import styled from "styled-components";

export const ContainerBody = styled.div`
  min-height: 100vh;
  height: fit-content;
  max-width: 1920px;
  margin: auto;
  background-color: #fff;
`;
